import React from 'react';

interface PricingItemListProps {
  children: React.ReactNode;
}

const PricingItemList: React.FC<PricingItemListProps> = ({ children }) => <ul>{children}</ul>;

export default PricingItemList;
